import { FileText } from "lucide-react";
import { librarySectionHeadingClassName } from "@/components/library/libraryNavStyles";

type LibraryDocumentsSectionProps = {
  documentCount: number;
  children: React.ReactNode;
  showHeading?: boolean;
};

export function LibraryDocumentsSection({
  documentCount,
  children,
  showHeading = true,
}: LibraryDocumentsSectionProps) {
  return (
    <section className="flex flex-col min-h-0 flex-1">
      {showHeading && (
        <div className="flex items-center gap-2 mb-2 shrink-0">
          <FileText className="h-3.5 w-3.5 text-muted-foreground" />
          <h2 className={librarySectionHeadingClassName + " mb-0"}>
            Documents
            {documentCount > 0 && (
              <span className="normal-case font-normal text-muted-foreground ml-1.5">
                ({documentCount})
              </span>
            )}
          </h2>
        </div>
      )}
      <div className="min-h-0 flex-1">{children}</div>
    </section>
  );
}
